import axios from 'axios'
import qs from 'qs'
import store from '../store'
import commTools from '../tools/common.js' //导入公共方法
import md5Tools from '../tools/md5.js' //MD5
// import Cookies from 'js-cookie'
import Vue from 'vue'
import 'babel-polyfill'

// 随机数生成
function  randomWord(randomFlag, min, max){
    var str = "",
        range = min,
        pos = "",
        arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  
    // 随机产生
    if(randomFlag){
        range = Math.round(Math.random() * (max-min)) + min;
    }
    for(var i=0; i<range; i++){
        pos = Math.round(Math.random() * (arr.length-1));
        str += arr[pos];
    }
    return str;
  }

// 新创建一个 axios ,用于 post 的对象传值，否则只能查询字符串形式的传值
let axios_new_http = axios.create({
    //设置请求时是否携带参数
    withCredentials: true,
    //是即将被发送的自定义请求头
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //允许在向服务器发送前，修改请求数据 , 只能用在 'PUT','POST'和 'PATCH',后面数组中的函数必须返回一个字符串，或 ArrayBuffer，或 Stream
    transformRequest: [function (data) {
        return qs.stringify(data); // 对 data 进行任意转换处理
    }],
    paramsSerializer: function (params) { //是一个负责 `params` 序列化的函数
        return qs.stringify(params, { arrayFormat: 'brackets' })
    },
}), httpObj = {};
//新创建一个 axios ,用于 post 的对象传值，否则只能查询字符串形式的传值
let axios_new_http_kf = axios.create({
    //设置请求时是否携带参数
    withCredentials: true,
    //是即将被发送的自定义请求头
    headers: {
        "Content-Type": "application/json"
    },
    //允许在向服务器发送前，修改请求数据 , 只能用在 'PUT','POST'和 'PATCH',后面数组中的函数必须返回一个字符串，或 ArrayBuffer，或 Stream
    transformRequest: [function (data) {
        return JSON.stringify(data);// 对 data 进行任意转换处理
    }],
    paramsSerializer: function (params) { //是一个负责 `params` 序列化的函数
        return qs.stringify(params, {
            arrayFormat: 'brackets'
        })
    }
});

//http request 拦截器-------------------------------------------------
axios_new_http.interceptors.request.use(
    config => {
        store.commit('upPwdBtnState', false); // 提交后 设置密码框的 提交按钮 不可用 
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);

//http response 拦截器-------------------------------------------------
axios_new_http.interceptors.response.use(
    response => {
        // 不等于 0 即为请求失败 弹框提示，
        // 排除开户(因开户失败跳转结果页),排除注册(因注册失败要跳转页),图片验证码, 手机校验码, 
        // 申购(因要跳转页)，赎回，转换,定投,修改分红,
        // 预约赎回,预约转换,校验用户密码
        let strResp = ['account/open', 'account/user/register', 'other/picVerificationCode/validate',
            'other/sms/validate', 'trade/buy', 'trade/redeem', 'trade/transfer', 'trade/fixed/buy',
            'trade/fixed/transfer', 'trade/bonus/change', 'trade/withdraw', 'trade/hope/redeem',
            'trade/hope/transfer', 'account/password/validate', 'account/bank/change/apply',
            'account/password/modify', 'account/password/reset', 'trade/hope/buy', 'trade/redeemToBuy',
            'trade/hope/transfer'];
        let isShowErrModel = false;
        let strRespURL = response.request.responseURL || response.config.url;
        let dataInfo = ''; //是否弹公共错误提示框
        //遍历 是否可以弹框
        for (let t in strResp) {
            if (strRespURL.indexOf(strResp[t]) > 0) {
                isShowErrModel = true;
                break;
            }
        }
        //判断 当前路径是不是 可以 使用默认 错误弹框的
        if (response.data.code != 0 && !isShowErrModel) {
            //以下特定提示，其余的视为请求错误，提示默认值
            if (response.data.code == '90000003' || response.data.code == '90000004' ||
                (response.data.code == '90000002' && response.data.message.indexOf('Token') > -1) ||
                (response.data.code == '90000002' && response.data.message.indexOf('未登录') > -1)) {
                // let tmpPath = document.location.pathname, tmpSearch = document.location.search;
                // if(tmpPath.indexOf('fundsFixed/buy') > -1){
                //     if(tmpPath && tmpSearch){
                //         commTools.setSession('tkamc_web_url',tmpPath + tmpSearch);
                //     }else if(tmpPath){
                //         commTools.setSession('tkamc_web_url',tmpPath);
                //     }
                // }
                //清空状态里的 state
                store.commit('upUserInfo', null);
                commTools.showErrorMsg_model('登录超时，请重新登录后重试', '/login', '提示', false);
            } else {
                //排除若密码
                if (response.data.message && response.data.message.indexOf('增加密码强') < 0) {
                    commTools.showErrorMsg_model(response.data.message);
                }
            }
        } else if (response.data.message.indexOf('请重新登录') > -1 || response.data.code == '90000003') {
            //清空状态里的 state
            store.commit('upUserInfo', null);
            commTools.showErrorMsg_model('登录超时，请重新登录后重试', '/login', '提示', false);

            // let tmpPath = document.location.pathname, tmpSearch = document.location.search;
            // if(tmpPath.indexOf('fundsFixed/buy') > -1){
            //     if(tmpPath && tmpSearch){
            //         commTools.setSession('tkamc_web_url',tmpPath + tmpSearch);
            //     }else if(tmpPath){
            //         commTools.setSession('tkamc_web_url',tmpPath);
            //     }
            // }
        }
        // 特殊错误
        if (response.data.code.indexOf('ETS') > -1) {
            commTools.showErrorMsg_model(response.data.message, '/fundslist', '', false);
        }
        //判断是不是 交易接口的准备接口 **/pre , 如果是 提取 票据 ticket
        if (response.config.url.indexOf('/pre') > -1 && response.data.data && response.data.data.ticket) {
            store.commit('upTicket', response.data.data.ticket); //将票据凭证 放在状态里
        }
        //拿到返回数据
        dataInfo = response.data.data || response.data.dataMap || response.data.dataList;
        //-- 返回数据里 脱敏
        dataInfo = httpObj.decryptParams(dataInfo);
        // 接到返回参后 设置密码框的 提交按钮 可用 
        store.commit('upPwdBtnState', true);
        return response;
    },
    error => {
        return Promise.reject(error)
    }
);

// 客服拦截器
//http request 拦截器-------------------------------------------------
axios_new_http_kf.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);

//http response 拦截器-------------------------------------------------
axios_new_http_kf.interceptors.response.use(
    response => {
        // var cc = commTools.encryptionAES_kf(Vue.prototype,'欢迎光临','Y6FnP+De5+kjMjsyvoWl9Q==');
        // console.log('加密后的AES',cc)
        // var dd = commTools.decryptAES_kf(Vue.prototype,cc,'Y6FnP+De5+kjMjsyvoWl9Q==')
        // console.log('解密后的AES',JSON.stringify(dd))


    //  let encryptionRSA = httpObj.encryptionRSA_kf('EBeiYe8YvHPVAeOP');
    //  console.info('encryptionRSA:',encryptionRSA);
    //  let decryptRSA  = httpObj.decryptRSA_kf(encryptionRSA);
    //  console.info('decryptRSA:',decryptRSA);
        let result = response.data;
        let aesKey = httpObj.decryptRSA_kf(result.encrypted);
        response =  JSON.parse( commTools.decryptAES_kf(Vue.prototype,result.responseData,aesKey))
        return response;
    },
    error => {
        return Promise.reject(error)
    }
);
// 网络请求的 axios 封装
httpObj = {
	/**
	 * 封装get方法
	 * @param url
	 * @returns {Promise}
	 */
    axios_get: function (url) {
        return new Promise((resolve, reject) => {
            axios_new_http.get(url)
                .then(
                    response => {
                        resolve(response.data);
                    },
                    err => {
                        reject(err)
                    }
                )
                .catch(err => {
                    reject(err)
                })
        })
    },
	/**
	 * 封装post请求
	 * @param url
	 * @param data
	 * @returns {Promise}
	 */
    axios_post: function (url, param, config) {
        // 判断是否有cookie, 否则不让访问
        if(store.state.userInfo.token && url != '/account/user/login' && url != 'account/user' && url != '/account/user' && 
          url!='other/banners' && url!='query/user/show/messages' && url!='/account/user/privacy' && url!='/account/user/privacy/save' && 
          (!commTools.getCookie('TKAMC_USERINFO') || 
          (commTools.getCookie('TKAMC_USERINFO') && !JSON.parse(commTools.getCookie('TKAMC_USERINFO')).token))){
           // 弹框 提示超时
            if(!commTools.getCookie('TKAMC_LOGINOUT') || commTools.getCookie('TKAMC_LOGINOUT') == ''){
              commTools.setCookie('TKAMC_LOGINOUT',1)
              store.commit('upUserInfo', null);
              commTools.delCookie('TKAMC_USERINFO');
              
              // commTools.showErrorMsg_model('登录超时，请重新登录后重试', '/login', '提示', false);
            } 
        }
        // 判断cookie 和 state 是否一致
        if(store.state.userInfo.token && commTools.getCookie('TKAMC_USERINFO')){
            // 如果不一致,则替换成 cookie 里的 用户信息
            if(store.state.userInfo.identityNo != JSON.parse(commTools.getCookie('TKAMC_USERINFO')).identityNo){
                console.log('333',store.state.userInfo.identityNo);
                console.log('444',JSON.parse(commTools.getCookie('TKAMC_USERINFO')).identityNo);
                store.commit('upUserInfo', null);
                store.commit('upUserInfo', JSON.parse(commTools.getCookie('TKAMC_USERINFO')));
            }
        }
        //复制一个新对象,使之和之前对象没有关系 	
        let params = Object.assign({}, param)
        // 从 状态 和 cookie 同时里取用户信息
        if(params) {
            if(url != 'account/user/type'){
                if (store.state.userInfo.token) {
                    params.token = store.state.userInfo.token;
                }
                //可从 cookie 里取 用户信息
                else if(commTools.getCookie('TKAMC_USERINFO') && JSON.parse(commTools.getCookie('TKAMC_USERINFO'))){ 
                    params.token = JSON.parse(commTools.getCookie('TKAMC_USERINFO')).token
                    //清空状态里的 userInfo
                    store.commit('upUserInfo', null);
                    //更新状态里的 userInfo
                    store.commit('upUserInfo', JSON.parse(commTools.getCookie('TKAMC_USERINFO')));
                }
            }
        }
        //可从 cookie 里取 用户信息
        else if(commTools.getCookie('TKAMC_USERINFO') && JSON.parse(commTools.getCookie('TKAMC_USERINFO'))){ 
            params.token = JSON.parse(commTools.getCookie('TKAMC_USERINFO')).token;
            //清空状态里的 userInfo
            store.commit('upUserInfo', null);
            //更新状态里的 userInfo
            store.commit('upUserInfo', JSON.parse(commTools.getCookie('TKAMC_USERINFO')));
        }
        //判断是不是有 凭证(主要用在交易相关接口)
        if (store.state.ticket !== '') {
            params.ticket = store.state.ticket; //-- 将票据加在 请求参数里
            //store.commit('upTicket','');  //-- 清空之前存的,每个票据只能用一次(得优化,先判断是交易接口再清空)
        }
        //定义 数组 保存参数的 key -- 定义 **************** 签名开始
        let arryKey = [], str = 'TAIKANG';
        for (let t in params) {
            arryKey.push(t)
        }
        arryKey.sort(); //数组排序
        //遍历取出 排序后对应的 key 对应的值
        for (let t in arryKey) {
            if (params[arryKey[t]] != undefined && arryKey[t] != 'signMsg') {
                str += arryKey[t] + params[arryKey[t]];
            }
        }
        str += 'TAIKANG';//末尾加上 密码
        //utf-8 编码
        str = eval('\'' + encodeURI(str).replace(/%/gm, '\\x') + '\'');
        // console.log('str',str);
        // console.log('签名字符串',str)
        //md5 加密
        str = md5Tools.hex_md5(str);          
        // console.log('签名字符串MD5',str);  
        //重新处理 参数，把md5签名加上  ****************** 签名结束
        params.signMsg = str;
        // console.log('params',params)
        for (let p in params) {
            if (['password', 'oldPassword', 'newPassword', 'tradePassword', 'newTradePassword', 'newBankAcco',
                'identityNo', 'mobilePhone', 'bankAcco', 'beneficiaryIdNo', 'holdIdNo'].includes(p)) {
                //如果包含密码,身份证号,手机号,银行卡号，则RSA加密
                params[p] = httpObj.encryptionRSA(params[p])
                // console.log('签名字符串RSA'[p],params[p]);
            }
        }
        axios_new_http.defaults.headers = { "Content-Type": "application/x-www-form-urlencoded" }
        // 设置 axios http 请求的默认 基础地址 
        axios_new_http.defaults.baseURL = process.env.BASE_URL;
        return new Promise((resolve,reject) => {
            axios_new_http.post(url, params, config)
                .then(
                    response => {
                        resolve(response.data);
                    },
                    err => {
                        reject(err)
                    }
                )
                .catch(err => {
                    throw new Error(err);
                })
        }).catch(err => {
            throw new Error(err);
        })
    },
    /**
	 * 封装axios_uploader请求
	 * @param url
	 * @param data
	 * @returns {Promise}
	 */
    axios_uploader: function (url, params) {
        // 创建一个新的 请求 
        let axios_new = axios.create({
            //设置请求时是否携带参数
            withCredentials: true,
            transformRequest: [function (data) {
                return data;
            }],
        });
        // 设置 axios http 请求的默认 基础地址
        axios_new.defaults.baseURL = process.env.BASE_URL;
        //上传，则启用新的请求头
        return new Promise((resolve, reject) => {
            axios_new.post(url, params)
                .then(
                    response => { resolve(response.data); },
                    err => { reject(err) }
                )
                .catch(err => {
                    reject(err)
                })
        })
    },
    /**
     * 封装客服请求
     * @param url
     * @param data
     * @returns {Promise}
     */
    axios_post_kf: function (url, params) {
        axios_new_http_kf.defaults.headers = { 
            "Content-Type": "application/json",
        "refresh": randomWord(false,16)
     };

     let aesKey = randomWord(false,16);
     let kf_obj_htp = {};
     console.log('aesKey',aesKey)
     let encryption = httpObj.encryptionRSA_kf(aesKey);
     console.info('encryption:',encryption)
     let requestData =commTools.encryptionAES_kf(Vue.prototype,JSON.stringify(params),aesKey)
     console.info('aes解密：',commTools.decryptAES_kf(Vue.prototype,requestData,aesKey))
     console.info('requestData:',requestData)
     kf_obj_htp.requestData = requestData
     kf_obj_htp.encrypted = encryption;
        axios_new_http_kf.defaults.baseURL = process.env.BASE_URL_KF;
        params = kf_obj_htp
        return new Promise((resolve, reject) => {
            axios_new_http_kf.post(url, params).then(
                response => {
                    resolve(response);
                },
                err => {
                    reject(err)
                }
            )
            .catch(err => {
                reject(err)
            })
        })
    },
    /**
  * 封装axios_uploader请求
  * @param url
  * @param data
  * @returns {Promise}
  */
    axios_uploader_kf: function (url, params) {
        // 创建一个新的 请求 
        let axios_new_kf_upload = axios.create({
            //设置请求时是否携带参数
            withCredentials: true,
            transformRequest: [function (data) {
                return data;
            }],
        });
        // 设置 axios http 请求的默认 基础地址
        axios_new_kf_upload.defaults.baseURL = process.env.BASE_URL_KF;
        //上传，则启用新的请求头
        return new Promise((resolve, reject) => {
            axios_new_kf_upload.post(url, params)
                .then(
                    response => {
                        let result = response.data;
                        // console.log('result',result)
                        let aesKey = httpObj.decryptRSA_kf(result.encrypted);
                        // console.log('aesKey',aesKey)
                        response =  JSON.parse( commTools.decryptAES_kf(Vue.prototype,result.responseData,aesKey))
                        // console.log('response',response)
                        // return response;
                        resolve(response);

                        // resolve(response.data);
                     },
                    err => { reject(err) }
                )
                .catch(err => {
                    reject(err)
                })
        })
    },
    /**
     * 封装同时执行多个请求
   * @param httpList  是一个对象数组，包含多个请求信息
   * @returns {Promise}
   */
    axios_all: function (httpList) {
        let arrHttp = []; //请求数组
        for (var obj of httpList) {
            if (obj.type == 'get') {
                arrHttp.push(axios_new_http.get(obj.url));
            } else if (obj.type == 'post') {
                arrHttp.push(axios_new_http.post(obj.url, obj.params));
            }
        }
        return new Promise((resolve, reject) => {
            axios_new_http.all(arrHttp)
                .then(axios_new_http.spread(function () {
                    var tmp = [];
                    for (var val of arguments) {
                        tmp.push(val.data)
                    }
                    resolve(tmp);
                }));
        })
    },
    // 把返回参数中的 特殊字段脱敏
    decryptParams: (dataInfo) => {
        if (dataInfo instanceof Array) { //-- 如果是 数组
            dataInfo.map((val, k) => {
                for (let o in val) {
                    if (['beneficiaryIdNo', 'holdIdNo', 'identityNo', 'mobilePhone', 'bankAccount', 'newBankAcco',
                        'bankAcco', 'identityFrontFilePath', 'identityBackFilePath'].includes(o)) {
                        val[o] = httpObj.decryptRSA(val[o]);
                        dataInfo[o] = val;
                    }
                }
            });
        } else if (dataInfo instanceof Object) {
            for (let o in dataInfo) { //-- 如果是 对象
                if (['beneficiaryIdNo', 'holdIdNo', 'identityNo', 'mobilePhone', 'bankAccount', 'newBankAcco',
                    'bankAcco', 'identityFrontFilePath', 'identityBackFilePath'].includes(o)) {
                    dataInfo[o] = httpObj.decryptRSA(dataInfo[o]);
                }
            }
        }
        //此处 只是 更新了dataInfo , 没有再更新回 response.data,是因为利用了 对象引用类型
        return dataInfo;
    },
    // RSA加密
    encryptionRSA: (params) => {
        //-- 1.初始化 RSA 对象
        let encryptorObj = new Vue.prototype.$jsEncrypt(), encryptorStr = '';
        //-- 2.设置 公钥
        encryptorObj.setPublicKey(httpObj.publicKey);
        if(params == null){
          params = ''
        }
        //-- 3.加密 
        encryptorStr = encryptorObj.encrypt(params);
        //返回 加密后的 字符串
        return encryptorStr;
    },
    // RSA解密
    decryptRSA: (params) => {
        //-- 1.初始化 RSA 对象
        let decryptObj = new Vue.prototype.$jsEncrypt(), decryptStr = '';
        //-- 2.设置 私密
        decryptObj.setPrivateKey(httpObj.privateKey)
        //-- 3.解密 
        decryptStr = decryptObj.decrypt(params);
        //返回 加密后的 字符串
        return decryptStr;
    },
    // RSA加密
    encryptionRSA_kf: (params) => {
        //-- 1.初始化 RSA 对象
        let encryptorObj = new Vue.prototype.$jsEncrypt(), encryptorStr = '';
        //-- 2.设置 公钥
       encryptorObj.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCUBrwBUPpcpRCye24Qgh16t+XhxMZZSVIKYt/Bi08A/E2LKms2gXkh5EzlovkCbHMq/UbQ0bLrVf7Q93URT4lj6qJIOEQ8acT68pZIBfsNVwFMRLls5lDX/iJXkw/dxf8zdVSdsUKut7U9bHs0Wa0MaIzN+edsjCHyRwljpucpPQIDAQAB') 
       
    //    测试RSA公和私
    // encryptorObj.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDB5KxFIFMePX/VtYdeTKp4m9Q0vCjLfUi5B3FrZWB42kNzGAkxfX+6qgrW6bLWQ1fAVyM3aaG2iiD39X5CgvsHS6+grEgQprQBTtXQWGfRyasnJteRLfmf7Iq7vkqAWuwmHOpMSItkqPdBcMOjRnjCOxHFZDGzLddUJz9NgRmFuwIDAQAB')
      
       //-- 3.加密 
        encryptorStr = encryptorObj.encrypt(params);
        //返回 加密后的 字符串
        return encryptorStr;
    },
    // RSA解密
    decryptRSA_kf: (params) => {
        //-- 1.初始化 RSA 对象
        let decryptObj = new Vue.prototype.$jsEncrypt(), decryptStr = '';
        //-- 2.设置 私密
       decryptObj.setPrivateKey('MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAOwt4riOLj3VWdRjoN2t2WJey4CGMNBcoX44Ke7dcPJy2Dc4lO20eDZaXUz45juGYtDD44zA6e0xcgp1Fe4j8vlJY1BNmMBKrx4HcpxYzrTTm01AOtOew8gQEcWz5rjcR77uxMRec7YSHjLl2zoK8mA/NYbOeCY4gHdSKPjRuwtVAgMBAAECgYEA1W6uGaxbe4OHt1kFce9+qNgTvaUHDfT3+BGXS4aQYHmKjXSzmZDipfPJpxqzLQ3H1POBepyHidOKRIsE831HP2X94dn7c/8FN1Eyej6JxMDjIMeSpRKItAq8KqCmZvcsB8oUfJMDbR6ekLmROPcgAAeV/pvKuWPhl8yuVoBclkECQQD92NxekNMZaQ407D0HAU3RD6uPHN2501K7thqtNvceRX0+758DU8R49RnTtopzsxeSFV+WCFrR70SDLgKARLcFAkEA7i6qT7PMPo0trRNds+6B1AXcQAM/v2vEoNFfWlkv/UkwX/BMCkf03+HezHcAUy9uwClqXN2DATwjLEAn7KyUEQJADSdjo/LVPYfYGJ31O5uxsJejSDMyuiJdMyTolPk4LPVk3BIGp2F72Ni6keHvorcxDXzWCyw7qI1Be5qyvnrREQJBAIXTlH/53x2aR3rCsdiCf1H5BPq2mJ/eVnmhinkCObOP5u1Q3/i623zbtUqe5oDW2tx/qLKLB6uu9XhMh+I0SXECQFB+2j4jZHfh3WzXVlpnrXoL5qNJA1YXITRbTYY8C+pvPjrV4Cz8Jfahe8zk33heg6HnepUT1Cw5qb0UCmeJRnU=');
       
        //    测试RSA公和私
        // decryptObj.setPrivateKey('MIICeQIBADANBgkqhkiG9w0BAQEFAASCAmMwggJfAgEAAoGBAMHkrEUgUx49f9W1h15Mqnib1DS8KMt9SLkHcWtlYHjaQ3MYCTF9f7qqCtbpstZDV8BXIzdpobaKIPf1fkKC+wdLr6CsSBCmtAFO1dBYZ9HJqycm15Et+Z/siru+SoBa7CYc6kxIi2So90Fww6NGeMI7EcVkMbMt11QnP02BGYW7AgMBAAECgYEAjAh/cp1Z6mk4PjyQu8ZbCChjJoMOY4jkUN3TSGE7P41DUYh2e0vMSCAvG/BEvQJ+CeflA0xDAvbXwL2Ipri6WtK7LRcUC3UoFqvnwG+7mR30n8uklWzWVJztOaxfllcSNhJnzcXsAmDhjrFddYUWKA19zX2uAA9X79Qqf6xuXiECQQD5Bx7RuY4f+MWsieZ4IHw3ytdr6edTIdei7of+2ndNKOfyILpUs5wC69QHGKgRaS0dHhI6W4fsHBFF75oaiOiNAkEAx1JhsVvOhYAsA5LJO4hMPKuk0R+L8ssj2TAUtyUUPvpcc7TzmdWIPPd2DPw5ep4EbY56WrCaK0vvXuh73vMJZwJBAN6jXwphuo8a+p+nKkV7xZKb5ry0Afxw5TjlyPAwoTh6uePfHrdbXL+/13AAu0HVpl/B4soJyxtsfITqEfxnKoECQQCsVfZRuucdVmy3yjpjVr1T17Rxe60tB6a/Kms+zrhqm11ETbgx0gYxcGSJZars8aMydnYj433o4YbdsHUpl0kRAkEAhGg2VvlD/cxzYQFrPDvz6KmeNZChOPQg8s94jp8xjvvKkXZe9DMGwpO2btOKlFcJTYv+WiqeEKIzpIvrqA63bg==');
       
       //-- 3.解密 
        decryptStr = decryptObj.decrypt(params);
        //返回 加密后的 字符串
        return decryptStr;
    },
    // RSA 公钥
    publicKey: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAIgnqeyWmfXA5H2M0iMfG55wJKsZCmVoNG1DhhLrdlKEOKXUOAJ80wYfIDojC8CAnL3RN8Y6mUWOF4DzMIkiC4ECAwEAAQ==',
    // RSA 私钥
    privateKey: 'MIIBVQIBADANBgkqhkiG9w0BAQEFAASCAT8wggE7AgEAAkEAzM3GrF8s4l9diiPT6ty9pBguHLwALDSvb+iZ9VTWAO/jOXEcYKHQHtSvcgijOmZ2k6VZ8964wkT2I549ucZu0wIDAQABAkEAxnaSE++W+zcW2gqmDW4jh6S26rl0IWJcr8FjkE3Jo9UXAW6e8Rokwxcrms+jqqXqylfSAW2vmiGV98d8fwEdwQIhAOy+uOeUv9E34YYTxa3IMih18XSdB1Fk1CHnOBYW0Kr5AiEA3XYBOuiUPQ4VPJy6kohWC/l6UNlE8hzDRToixY+GLysCID9Cl1YKQVc+f1y8W84b+IsnOOXYL+Rn9Oc6SZpdblTBAiBrLWH5BXhAeCFU/TDaG7sw/mLw38WbOspSJYmQfR5ekwIhAMOac+yF2HPoHUJHz2P8igZIigyO91r0PSLJNEKMJL1g'
    // 上述 公钥 和 私钥 不是一套, 因 前端 js RSA 只能 公钥加密,私钥解密
    // 故 往后端发送数据时, 前端 使用 第一套 公钥 加密, 后端使用 第一套 私钥解密
    // 后端往前端发送数据时, 后端 使用 第二套 公钥 加密, 前端使用 第二套 私钥解密
}
export default httpObj;


// WEBPACK FOOTER //
// ./src/http/http_axios.js